import {
  // -- GET (list)
  GET_PROJECT_LOCATIONS_SUCCESS,
  GET_PROJECT_LOCATIONS_FAILURE,
  // -- CREATE
  CREATE_PROJECT_LOCATION_SUCCESS,
  CREATE_PROJECT_LOCATION_FAILURE,
  // -- UPDATE
  UPDATE_PROJECT_LOCATION_SUCCESS,
  UPDATE_PROJECT_LOCATION_FAILURE,
  // -- DELETE
  DELETE_PROJECT_LOCATION_SUCCESS,
  DELETE_PROJECT_LOCATION_FAILURE,
  // -- SEARCH
  SEARCH_PROJECT_LOCATIONS
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'

let cacheItems = null

export const projectLocations = (state = {}, action) => {
  switch (action.type) {
    // -- GET PROJECT LOCATIONS (list)
    case GET_PROJECT_LOCATIONS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectLocations.GET_PROJECT_LOCATIONS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_PROJECT_LOCATIONS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectLocations.GET_PROJECT_LOCATIONS_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE PROJECT LOCATION
    case CREATE_PROJECT_LOCATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectLocations.CREATE_PROJECT_LOCATION_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_PROJECT_LOCATION_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectLocations.CREATE_PROJECT_LOCATION_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE PROJECT LOCATION
    case UPDATE_PROJECT_LOCATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectLocations.UPDATE_PROJECT_LOCATION_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_PROJECT_LOCATION_SUCCESS: {
      const items = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectLocations.UPDATE_PROJECT_LOCATION_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- DELETE PROJECT LOCATION
    case DELETE_PROJECT_LOCATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectLocations.DELETE_PROJECT_LOCATION_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_PROJECT_LOCATION_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectLocations.DELETE_PROJECT_LOCATION_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- SEARCH PROJECT
    case SEARCH_PROJECT_LOCATIONS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }

    default:
      return state
  }
}
